<template>
  <div class="menu-box-wrapper">
    <template>
      <div class="menu-item" @click="jobscanClickFunc">
        <div class="menu-item-icon">
          <img src="https://logo.wondercv.com/banners/Zxm4VkqSCCIDuG5.png" alt="" class="menu-banner">
          <img v-if="tips[0]" :src="tips[0].image" alt="" class="menu-tips">
        </div>
        <h6 class="menu-item-title">简历分析报告</h6>
      </div>
      <div class="menu-item" @click="planClickFunc">
        <div class="menu-item-icon">
          <img src="https://logo.wondercv.com/banners/cnfnavQXiz7RKCz.png" alt="" class="menu-banner">
          <img v-if="tips[1]" :src="tips[1].image" alt="" class="menu-tips">
        </div>
        <h6 class="menu-item-title">专属求职规划</h6>
      </div>
    </template>
    <template v-for="(item, index) in banner">
      <div class="menu-item" :key="`a&${index}`" v-if="item && item.image" @click.stop="jumpFunc(item)" data-growing-container :data-growing-idx="307 + index">
        <div class="menu-item-icon">
          <!-- <i :class="['iconfont', item.icon]"></i> -->
          <img :src="item.image" alt="" class="menu-banner">
          <img v-if="tips[index]" :src="tips[index].image" alt="" class="menu-tips">
          <!-- <img v-if="tips[index]" src="https://files.wondercv.com/PC/cvs/resume_pattern.png" alt="" class="menu-tips"> -->
        </div>
        <h6 class="menu-item-title">{{ item.title }}</h6>
      </div>
    </template>

  </div>
</template>

<script>
import { routerTo } from '@/assets/js/util'
import api from "@/api"

export default {
  props: {
    skeletonContentTopVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      menuMap: [
        {
          icon: 'iconzhiyeceping',
          title: '职业测评',
          url: '/jobscan/index',
          target: '_blank'
        },
        {
          icon: 'iconGPAjisuanqi',
          title: 'GPA计算器',
          url: '',
          target: '_blank',
          type: 'gpa'
        },
        {
          icon: 'icondaoshifudao1',
          title: '导师辅导',
          url: '/service',
          target: '_blank'
        },
        {
          icon: 'iconbeizhanqiuzhao',
          title: '备战秋招',
          url: 'https://www.xiaozao.org/act2/resume?channel=119924',
          target: '_blank'
        }
      ],
      banner: [],
      tips: []
    }
  },
  mounted () {
    this.getBanner()
  },
  methods: {
    async getBanner() {
      Promise.all([
        // api.jobs.getBanner({position: '48'}), 
        // api.jobs.getBanner({position: '49'}), 
        api.jobs.getBanner({position: '50'}), 
        api.jobs.getBanner({position: '51'}),
        api.jobs.getBanner({position: '52'}),
        api.jobs.getBanner({position: '53'}),
        api.jobs.getBanner({position: '54'}),
        api.jobs.getBanner({position: '55'})])
        .then(resArr => {
          let bannerArr = []
          let tipsArr = []
          let [tool3, tool4, tips1, tips2, tips3, tips4] = resArr
          // if (tool1.code === 1000 && tool1.data.length) {
          //   bannerArr[0] = tool1.data.at(-1)
          // }
          // if (tool2.code === 1000 && tool2.data.length) {
          //   bannerArr[1] = tool2.data.at(-1)
          // }
          if (tool3.code === 1000 && tool3.data.length) {
            bannerArr[2] = tool3.data.at(-1)
          }
          if (tool4.code === 1000 && tool4.data.length) {
            bannerArr[3] = tool4.data.at(-1)
          }
          if (tips1.code === 1000 && tips1.data.length) {
            tipsArr[0] = tips1.data.at(-1)
          }
          if (tips2.code === 1000 && tips2.data.length) {
            tipsArr[1] = tips2.data.at(-1)
          }
          if (tips3.code === 1000 && tips3.data.length) {
            tipsArr[2] = tips3.data.at(-1)
          }
          if (tips4.code === 1000 && tips4.data.length) {
            tipsArr[3] = tips4.data.at(-1)
          }
          this.banner = bannerArr
          this.tips = tipsArr
      })
      // banner
      // let res = await api.jobs.getBanner({position: '2'});
      // if(res.data.length){
      //   this.banner = res.data[0] || {};
      // }

    },
    // 跳转方法
    jumpFunc (data) {
      // 需要特殊处理的类型
      // if (data.type && data.type === 'gpa') {
      //   const alertData = {
      //     show: true,
      //     type: data.type
      //   }
      //   this.$store.dispatch('app/setAlertData', alertData)
      // // 正常跳转
      // } else {
      //   routerTo(data.url, "_blank")
      // }
      window.open(data.link)
      // routerTo(data.url, "_blank")
    },
    planClickFunc() {
      this.$emit('planClickFunc')
    },
    jobscanClickFunc() {
      this.$emit('jobscanClickFunc')
    }
  }
}
</script>

<style lang="sass" scoped>
  @import "./index.scss";
</style>
